// extracted by mini-css-extract-plugin
export default {"container":"TopContentsTitle_container__3+hiR","block":"TopContentsTitle_block__mdYZR","logo":"TopContentsTitle_logo__zE1Ts","title":"TopContentsTitle_title__sbgGT"};